// eslint-disable-next-line react-hooks/exhaustive-deps
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateLeadSource } from "../../../components/desktop/settings/actions";
import SellMarketingInfo from "./component";

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateLeadSourceConnect: updateLeadSource
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SellMarketingInfo);

